import { ApplicationConfig, importProvidersFrom, provideAppInitializer, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';

import { routes } from './app.routes';
import { TranslocoRootModule } from './transloco-root.module';
import { AuthService } from './services/auth.service';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { provideNgxMask } from 'ngx-mask';
import { HomeModule } from './modules/home/home.module';
import { SessionExpiredDialogModule } from './modules/session-expired-dialog/session-expired-dialog.module';

export function initApp(authService: AuthService) {
  return () => authService.checkInitialTokenValiditySync();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),

    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },

    providePrimeNG({
      ripple: true,
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false
        }
      }
    }),
    provideAppInitializer(() => {
        const authService = inject(AuthService);
        return authService.checkInitialTokenValiditySync();
    }),
    MessageService,
    ConfirmationService,
    { provide: DialogService, useClass: DialogService },

    importProvidersFrom(
      TranslocoRootModule,
      HomeModule, 
      SessionExpiredDialogModule 
    ),

    provideNgxMask(),
    AuthService,
  ]
};